import { connect } from 'react-redux'
import { compose, lifecycle } from 'recompose'
import withType from 'components/common/hoc/withType'
import { getCurrentStoreNumber } from 'selectors/getCurrentStore'
import { getActiveVehicleId } from 'selectors/getActiveVehicle'
import BOTShoppingCartQuote from './BOTShoppingCartQuote'
import { getCartDetail } from '../actions'

const mapStateToProps = state => ({
  vehicleId: getActiveVehicleId(state),
  storeNumber: getCurrentStoreNumber(state)
})

const withCheckPropsAndUpdateCart = lifecycle({
  componentDidUpdate({ vehicleId: prevVehicleId, storeNumber: prevStoreNumber, handleTAOSDateTimeUpdate }) {
    const { vehicleId, storeNumber, getCartDetail } = this.props

    if (storeNumber !== prevStoreNumber || vehicleId !== prevVehicleId) {
      handleTAOSDateTimeUpdate && handleTAOSDateTimeUpdate()
      getCartDetail()
    }
  }
})

export default compose(
  withType({ type: 'BOTShoppingCartQuote', placeholders: ['leftContent', 'rightContent']}),
  connect(mapStateToProps, { getCartDetail }),
  withCheckPropsAndUpdateCart
)(BOTShoppingCartQuote)
